var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6161 20.5H19.1063C20.2561 20.5 21.1707 19.9761 21.9919 19.2436C24.078 17.3826 19.1741 15.5 17.5 15.5M15.5 5.56877C15.7271 5.52373 15.9629 5.5 16.2048 5.5C18.0247 5.5 19.5 6.84315 19.5 8.5C19.5 10.1568 18.0247 11.5 16.2048 11.5C15.9629 11.5 15.7271 11.4763 15.5 11.4312",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48131 16.6112C3.30234 17.243 0.211139 18.5331 2.09388 20.1474C3.01359 20.936 4.03791 21.5 5.32572 21.5H12.6743C13.9621 21.5 14.9864 20.936 15.9061 20.1474C17.7889 18.5331 14.6977 17.243 13.5187 16.6112C10.754 15.1296 7.24599 15.1296 4.48131 16.6112Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8C13 10.2091 11.2091 12 9 12C6.79086 12 5 10.2091 5 8C5 5.79086 6.79086 4 9 4C11.2091 4 13 5.79086 13 8Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateIcon);
export default __webpack_public_path__ + "static/media/candidateIcon.221e785af244231b29c129751441a800.svg";
export { ForwardRef as ReactComponent };